// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_oc-0";
export var discountCodeInput = "_oc-1";